/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Определяет состояние свидетельства. Переходит в EXPIRED за 3 месяца до истечения
 * @export
 * @enum {string}
 */
export enum RegistryStatus {
  Valid = 'VALID',
  Expired = 'EXPIRED',
  Expires = 'EXPIRES',
}

export function instanceOfRegistryStatus(value: any): boolean {
  for (const key in RegistryStatus) {
    if (Object.prototype.hasOwnProperty.call(RegistryStatus, key)) {
      if (RegistryStatus[key as keyof typeof RegistryStatus] === value) {
        return true
      }
    }
  }
  return false
}

export function RegistryStatusFromJSON(json: any): RegistryStatus {
  return RegistryStatusFromJSONTyped(json, false)
}

export function RegistryStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryStatus {
  return json as RegistryStatus
}

export function RegistryStatusToJSON(value?: RegistryStatus | null): any {
  return value as any
}
